var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('aside', {
    staticClass: "popup-form updates-center-popup",
    "class": {
      'updates-center-popup--capture-hidden': _vm.captureHidden
    }
  }, [_c('div', {
    staticClass: "updates-center-content"
  }, [_c('header', {
    staticClass: "updates-center-header"
  }, [_c('button', {
    staticClass: "updates-close",
    attrs: {
      "type": "button",
      "aria-label": "Zavrieť"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "close",
      "size": 24
    }
  })], 1), _c('span', {
    staticClass: "updates-kicker"
  }, [_vm._v("Čo je nové v Bankároch")]), _c('h2', [_vm._v("Novinky a podpora")]), _c('p', [_vm._v("Prehľad zmien v aplikácii, metodike bánk a nové odborné články.")])]), _c('nav', {
    staticClass: "updates-tabs",
    attrs: {
      "aria-label": "Novinky a spätná väzba"
    }
  }, [_c('button', {
    "class": {
      active: _vm.activeTab === 'updates'
    },
    attrs: {
      "type": "button",
      "aria-selected": _vm.activeTab === 'updates'
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 'updates';
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "sparkles",
      "size": 19
    }
  }), _vm._v(" Novinky ")], 1), _c('button', {
    "class": {
      active: _vm.activeTab === 'feedback'
    },
    attrs: {
      "type": "button",
      "aria-selected": _vm.activeTab === 'feedback'
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 'feedback';
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "feedback",
      "size": 19
    }
  }), _vm._v(" Nahlásiť problém ")], 1)]), _vm.activeTab === 'updates' ? _c('section', {
    staticClass: "updates-feed",
    attrs: {
      "aria-label": "Zmeny v aplikácii"
    }
  }, _vm._l(_vm.updates, function (item) {
    return _c('article', {
      key: item.id,
      staticClass: "update-card",
      "class": "update-card--".concat(item.type)
    }, [_c('div', {
      staticClass: "update-card-meta"
    }, [_c('span', {
      staticClass: "update-card-label"
    }, [_vm._v(_vm._s(item.label))]), item.bank ? _c('span', {
      staticClass: "update-card-bank"
    }, [_vm._v(_vm._s(item.bank))]) : _vm._e(), _c('time', [_vm._v(_vm._s(item.date))])]), _c('h3', [_vm._v(_vm._s(item.title))]), _c('p', [_vm._v(_vm._s(item.summary))]), item.link ? _c('a', {
      staticClass: "update-card-link",
      attrs: {
        "href": item.link,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v(" " + _vm._s(item.linkLabel || "Zistiť viac") + " "), _c('app-icon', {
      attrs: {
        "name": "arrow-right",
        "size": 17
      }
    })], 1) : _vm._e()]);
  }), 0) : _c('user-feedback-pop-up', {
    attrs: {
      "embedded": ""
    },
    on: {
      "capture-state": function captureState($event) {
        _vm.captureHidden = $event;
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }